// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rating-container {
  text-align: center;
  margin: 15px 0;
}

.rating-buttons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}

ion-button {
  min-width: 40px;
  padding: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/client/objective-client/progression-modal/progress-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;AACJ;;AAEE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;AACJ;;AAEE;EACE,eAAA;EACA,YAAA;AACJ","sourcesContent":[".rating-container {\r\n    text-align: center;\r\n    margin: 15px 0;\r\n  }\r\n  \r\n  .rating-buttons {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n  }\r\n  \r\n  ion-button {\r\n    min-width: 40px;\r\n    padding: 5px;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
